<template>
    <div>
        <div id="livechat" ref="livechat" :style="isMinimiez ? 'top:unset;left:unset' : ''" :class="[closeChat == true ? '__closed__chat' : '']" >
            <ChatMain ref="livechat__main">
                <Header @isMinimiez="handleMinimiez" :parentMinimiez.sync="isMinimiez" :parentOnline.sync="parentOnline" :isMobile="isMobile"  @interface="checkDrag" @parentCloseChatHeader="handleClose"  @parentCheckMe="checkMe"></Header>
                <!-- <router-link to="/">Home</router-link>
                <router-link to="/about" class="abojut">About</router-link> -->
                <div :class="[isMinimiez ? ['__is__minimiez'] : ['__is__expaned'] ]">
                    <router-view :clearErrorList.sync="clearErrorList" :isClose.sync="isClose" @statusOnlineUpdated="parentOnline = $event" @parentCloseChat="closeChatHandle"></router-view>
                </div>
                <Exit :cfmExit.sync="cfmExit" :room="null" :token="null" @parentcfmExit="cfmExit = $event"  @exitChat="closeChatHandle"></Exit>
            </ChatMain>
        </div>
        <!-- <button livechat-show="true">show</button> -->
    </div>
</template>
<script>

import Header from './blocks/Header.vue'
import ChatMain from './layouts/Main.vue'
import Vue from 'vue'
import VDragged from 'v-dragged'
import Chathub from '@/apis/chathub';
import Exit from './blocks/Exit'
import Validator from '@/functions/Validator';

let validator = new Validator;
let chathubObject = new Chathub;

Vue.use(VDragged) 

export default {
    name: 'livechat',
    components: {
        Header, ChatMain, Exit
    },
    data() {
        return {
            isMinimiez : false,
            isMove : false,
            parentMove : [],
            parentOnline : false,
            isClose : false,
            cfmExit : false,
            closeChat : true,
            isMobile : false,
            clearErrorList : false

        }
    }, 
    methods: {
        handleMinimiez: function(data) {
            // in ra data từ component-b gửi lên
            this.isMinimiez = data;
        },
        handleClose : function (data) {
            // this.isClose = true;
            this.cfmExit = true
        },
        onDragged({ el, deltaX, deltaY, offsetX, offsetY, clientX, clientY, first, last }) {
            if (validator.isME()) {
               
            } else {
                
                el = this.$refs.livechat
                var container = this.$refs.livechat__main
    
                if (first) {
                    this.isDragging = true
                    return
                }
                if (last) {
                    this.isDragging = false
                    return
                }
                var l = +window.getComputedStyle(el).getPropertyValue('left').slice(0, -2) || 0
                var t = +window.getComputedStyle(el).getPropertyValue('top').slice(0, -2) || 0
                var maxtop = screen.height - 105  - container.$el.offsetHeight;
    
                var maxleft = document.documentElement.scrollWidth - container.$el.offsetWidth;
                if ( maxleft <= 0) {
                    return false;
                }
                if (l < 0) {
                    l = 0;
                }
    
                if (t < 0) {
                    t = 0;
                }
    
                if (t > maxtop) {
                    t = maxtop
                }
    
                if (l > maxleft) {
                    l = maxleft
                }
                
                el.style.left = l + deltaX + 'px'
                el.style.top = t + deltaY + 'px'
            }
            // el.preventDefault()
          
        },
        checkDrag : function(event) {
            if(!this.isMinimiez) {
                if (validator.isME()) {
                   
                    // return alert('Chức năng không hỗ trợ trên trình duyệt này!!!')

                } else {
                    this.onDragged(event)
                }
            }
        },
        showChat : function (event) {
            this.closeChat = !this.closeChat
            localStorage.setItem("closeChat", this.closeChat);
            if(localStorage.getItem("isMinimiez") != null && localStorage.getItem("isMinimiez") == 'false') {
                localStorage.setItem('isMinimiez', false);
                if(this.isMinimiez == true) {
                    this.isMinimiez = false;
                }
            }
        }, 
        logoutChat : function (event) {
            if(this.$cookies.isKey('fpt_livechat')) {
                this.$cookies.remove('fpt_livechat');
            }
            if(this.$cookies.isKey('fpt_sso')) {
                this.$cookies.remove('fpt_sso');
            }

            // if(this.$router.currentRoute.path != '/') {
            //     this.$router.push('/');
            // }

            this.$emit('exitChat', true);

            localStorage.setItem("closeChat", true);
        },
        closeChatHandle : function (event) {
            this.closeChat = event
            this.cfmExit = false
            this.clearErrorList = true
        },

        checkMe : function () {
            if (validator.isME()) {   
                return alert(this.$t("validator.me.not_support"))
            }

        }
       
    },
    created () {
        if(validator.isMobileDevice()) {
            this.isMobile = true
        }
        if(localStorage.getItem("isMinimiez") != null) {
            if (localStorage.getItem("isMinimiez") == 'true') {
                this.isMinimiez = true
            } else {
                this.isMinimiez = false
            }
        }

        if(localStorage.getItem("closeChat") != null) {
            if (localStorage.getItem("closeChat") == 'true') {
                this.closeChat = true
            } else {
                this.closeChat = false
            }
        }
    },
    mounted () {
        if(document.querySelectorAll('[livechat-show="true"]')[0]) {
            document.querySelectorAll('[livechat-show="true"]')[0].addEventListener("click", this.showChat);
        }
        if(document.querySelectorAll('[livechat-event="logout"]')[0]) {
            document.querySelectorAll('[livechat-event="logout"]')[0].addEventListener("click", this.logoutChat);
        }

        var token = null;

        if(this.$cookies.isKey('fpt_livechat') && this.$cookies.get("fpt_livechat").token) {
            token = this.$cookies.get("fpt_livechat").token;
        }

        var chathub              = chathubObject.setToken(token);
        chathub.then(response => {
            this.parentOnline = response.data.config.online;
        })
        .catch(error => {
            this.parentOnline = false
        })
    }
    
    

}
</script>
<style lang="scss" module scoped>
    .__is__min {
        top: unset !important;
        left : unset  !important;
    }
    .__drag__container {
        width: inherit !important;
        height : inherit !important;

        bottom : 0px !important;
    }
</style>
<style lang="scss">
html {
    font-size: 10px;
}
</style>
<style scoped lang="scss" >

#livechat {
    font-family: 'Roboto', sans-serif;
    text-align: left;
    color: #000;
    margin: 0;
    padding: 0;
    border: 0;
    /* width: 313px; */
    .__is__minimiez {
        display:none;
    }
    .__is__expaned {
        display:block;
    }
    position:fixed;
    bottom: -5px;
    right : 0;
    width : 100%;
    z-index: 199999999;
    &.__closed__chat {
        display :none;
    }
}

@media screen and (min-width: 769px) {
    #livechat {
        width: 313px;
        right: 100px;
    }
}
</style>
<style scoped lang="scss">
@import "../styles/normalize.css";
#livechat /deep/ {

    @import "~bootstrap/dist/css/bootstrap.min";
    @import "~bootstrap-vue/dist/bootstrap-vue.css";
    @import "~material-icons/iconfont/material-icons.css";
    @import "~roboto-fontface/css/roboto/roboto-fontface.css";
    @import "../styles/main.scss";
   

}
</style>